export const DEFAULT_LOCALE = "de-DE";

export const DEFAULT_CURRENCY = "EUR";

export enum StatusColor {
  GOLD = "gold",
  GREEN = "green",
  ORANGE = "orange",
  PURPLE = "purple",
  GRAY = "gray",
  RED = "red",
}
